import Vue from 'vue'
import generateIconsView from '@/views/generateIconsView.js'// just for @/views/icons , you can delete it

// register globally
Vue.component('svg-icon')

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
const iconMap = requireAll(req)

generateIconsView.generate(iconMap) // just for @/views/icons , you can delete it



// WEBPACK FOOTER //
// ./src/icons/index.js